export enum RequirementSubjectType {
  FUSA_ORGANIZATION = 'fusaOrganization',
  PROJECT = 'project'
}

export interface RequirementParams {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  name: string;
  description: string;
  propelOrgId: string;
  type: string;
  subjectId: string;
subjectType: RequirementSubjectType;
  sourceId?: string | null;
  identifier?: string | null;
  applicable: boolean;
  comment?: string | null;
  assignedUserId: string | null;
  assignedSupplierUserId: string | null;
}

export interface RequirementData {
  id: string;
  createdAt?: string;
  updatedAt?: string;
  name: string;
  description: string;
  propelOrgId: string;
  type: string;
  subjectId: string;
  subjectType: RequirementSubjectType;
  sourceId?: string | null;
  identifier?: string | null;
  applicable: boolean;
  comment?: string | null;
  assignedUserId: string | null;
  assignedSupplierUserId: string | null;
}

export type RequirementCreateData = Omit<RequirementData, 'id' | 'createdAt' | 'updatedAt'>;

export type RequirementBulkCreateData = Omit<RequirementCreateData, 'propelOrgId' | 'subjectId' | 'subjectType'> & {
  id: string 
};
